import { IconButtonTypes } from '@lib/components/IconButton/IconButton';
import { TableAction } from '@lib/components/Table/types';
import { Task } from 'graphql-common';

export default function getTaskTableActions({
  onOpenTaskPage,
}: {
  onOpenTaskPage: (id?: string) => void;
}): TableAction<Task>[] {
  return [
    {
      id: 'view-action',
      icon: 'arrow_outward',
      onClick: (item: Task) => onOpenTaskPage(item?.id),
      type: IconButtonTypes.PrimaryOutlined,
    },
  ];
}
